'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const mediator = require('./../../../core/mediator');
const container = require('./../../../core/container');

const itemTpl = require('./../templates/menu_item.hbs');

let menu;
let menuElts = {
  'submit': {
    'elements': [],
  },
  'primary': {
    'elements': [],
  },
  'secondary': {
    'elements': [],
  },
};

const calculnextElement = function(item, nav) {
  let currentItem;
  let elts = container.get('isMobile') ? menuElts.primary : menuElts[nav];
  let delta = 100;
  let currentDelta;

  _.forEach(elts.elements, function(element) {
    currentDelta = element.order - item.order;
    if (currentDelta > 0) {
      if (currentDelta <= delta) {
        delta = currentDelta;
        currentItem = element;
      }
    }
  });

  return currentItem;
};

module.exports.add = function(name, icon, order, eventName, className, focus, params, nav) {
  let $menu;
  let html;
  let nextEl;
  let item = {
    'name': name,
    'icon': icon,
    'order': order,
    'className': className,
    'key': eventName,
    'eventName': 'menu:' + eventName + ':click',
    'focus': Boolean(focus),
    'params': params,
  };

  nav = nav || 'primary';
  $menu = container.get('isMobile') ? jQuery('#cloud-nav-secondary') : jQuery('#cloud-nav-' + nav);

  if (arguments.length < 4) {
    throw new Error('You must set all params');
  }

  html = jQuery(itemTpl(item));
  nextEl = calculnextElement(item, nav);
  item.html = html;

  mediator.publish('before:render:menu-item', item);

  if (nextEl) {
    if (container.get('isMobile')) {
      jQuery('#cloud-nav-primary').append(item.html);
    } else {
      nextEl.html.before(item.html);
    }
  } else {
    $menu.append(item.html);
  }

  if (item.publish !== false) {
    menu.publish(item.html, item, params);
  }

  menuElts[nav].elements.push(item);

  return item;
};

module.exports.init = function() {
  menu = container.get('isMobile') ? require('./mobile') : require('./desktop');

  menu.init();

  mediator.publish('menu:ready', module.exports.add);
};

module.exports.clear = function() {
  menuElts = {
    'primary': {
      'elements': [],
    },
    'secondary': {
      'elements': [],
    },
  };

  jQuery('#cloud-nav-primary').html('');
  jQuery('#cloud-nav-secondary').html('');
};

module.exports.hide = function() {
  if (!jQuery('.admin-container').length &&
    container.get('prevent-hide-overlay') !== true &&
    container.get('prevent-hide-toolbar') !== true) {
    jQuery('.cloud-toolbar-main').removeClass('show');
    container.get('$siteWrapper').removeClass('add-padding');
    jQuery('#header').removeClass('add-padding');
    mediator.publish('after:menu:hide');
  }
};

module.exports.show = function() {
  if (!jQuery('.admin-container').length &&
    container.get('prevent-hide-overlay') !== true &&
    container.get('prevent-hide-toolbar') !== true) {
    jQuery('.cloud-toolbar-main').addClass('show');
    container.get('$siteWrapper').addClass('add-padding');
    jQuery('#header').addClass('add-padding');

    mediator.publish('after:menu:show');
  }
};

module.exports.onError500 = function() {
  jQuery('#cloud-nav-submit > li').addClass('d-none');
  jQuery('#cloud-nav-primary > li').addClass('d-none');
};

